import { PasswdChangeModel } from './../classes/passwdChange';
import { ProfileModel } from './../classes/profile';
import { Subscription } from './../classes/subscription';
import { AxiosResponse } from 'axios';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import store from '@/store/index';
import { UserSteps } from '../classes/userSteps';

export class ProfileApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async getProfile(): Promise<ProfileModel> {
    const response: AxiosResponse<AppResponse<ProfileModel>> = await AuthorizedApiClient.get('/Account/GetProfileInfo');
    if(!response)
    {
      throw new Error();
    }
    const appResponse: AppResponse<ProfileModel> = response.data;
    if (appResponse.IsSuccess) {
      const user: ProfileModel = new ProfileModel(appResponse.Result);
      return user;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async getSubscription(): Promise<Subscription> {
    const response: AxiosResponse<AppResponse<Subscription>> =
        await AuthorizedApiClient.get('/Account/GetSubscription');
    const appResponse: AppResponse<Subscription> = response.data;

    if (appResponse.IsSuccess) {
      const user: Subscription = appResponse.Result;
      return user;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async updateProfile(profile: ProfileModel): Promise<boolean> {
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/Account/SetProfileInfo', {
      name: profile.name,
      language: profile.language,
      defaultPhoneNumberPrefix: profile.defaultPhoneNumberPrefix,
      marketingConsent: profile.marketingConsent,
      newsletterConsent: profile.newsletterConsent,
      accountName: profile.accountName
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async updatePassword(passwdChange: PasswdChangeModel): Promise<boolean> {
    const response: AxiosResponse<
      AppResponse<boolean>
    > = await AuthorizedApiClient.post('/Account/ChangePassword', {
      currentPassword: passwdChange.currentPassword,
      newPassword: passwdChange.newPassword,
      confirmPassword: passwdChange.newPasswordRepeat,
    });
    const appResponse: AppResponse<boolean> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async getSteps() : Promise<UserSteps> {
      const response : AxiosResponse<AppResponse<UserSteps>> 
      = await AuthorizedApiClient.get('/Account/UserSteps')
      const appResponse: AppResponse<UserSteps> = response.data;
      if(appResponse.IsSuccess)
      {
        return appResponse.Result;
      }
      else {
        throw new Error(appResponse.ErrorCodes.join(','));
      }
  }
}

declare global {
  var tidioChatApi: any;
}
